module.exports = {
  "country": "IL",
  "artist": "Dana International",
  "song": "Diva",
  "year": "1998",
  "place": "1",
  "spotify": "1rqPSD8vhtf6jvw3uFTAsz"
};